<template>
  <!-- <b-container class="card-container"> -->
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `image_template`}">Images</b-link> / {{item ? item.name : ''}}</span>
        <!-- <b-button size="sm" variant="secondary float-right" :to="{name: `${collection}_edit`, params: {from_item: item}}" >Edit</b-button> -->
        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fimage_template~2F${$route.params.id}~2Fimage~2F${$route.params.image}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <b-row>
          <b-col>
            <img :src="item.image_url" />
          </b-col>
          <b-col>

            <div v-if="item.first_name" class="mb-2">
              <p><strong>First Name:</strong> {{item.first_name}}</p>
            </div>
            <div v-if="item.website" class="mb-2">
              <p><strong>Website:</strong> {{item.website}}</p>
            </div>

            <!-- <b-button @click="render_image_api">Render</b-button> -->

            <!-- <b-button v-b-toggle.collapse-1 variant="secondary" size='sm' class='mb-2'>Shareable link <i class='when-open far fa-angle-up' key="up"></i><i class='when-closed far fa-angle-down' key="down"></i></b-button>
            <b-collapse id="collapse-1" class="mb-2">
              <b-card>
                <p>Shareable thumbnail with link. Copy and paste into your email.</p>
                <p><a :href="item.video_player_url" target='_blank'><img :src="item.thumbnail_url || project.thumbnail_url" width='480' height="360"/></a></p>
                <b-button @click="copy_html_to_clipboard(code)" size="sm" class='d-inline-block'>Copy to clipboard</b-button>

              </b-card>
            </b-collapse> -->
          </b-col>
        </b-row>
      </div>
    </b-card>
  <!-- </b-container> -->
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Item'},
  mixins: [ItemMixin],
  props: ['image_template'],
  firestore: function () {
    return {
      item: db.collection('image_template').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.image),
    }
  },
  data() {
    return {
      collection: 'image'
    }
  },
  computed: {
    code() {
      return `<a href="${this.item.video_player_url}" target='_blank'><img src="${this.item.thumbnail_url || this.project.thumbnail_url}" width='480' height="360"/></a>`
    }
  },
  methods: {
    render_image_api() {
      api.render_image_api(this.$route.params.id, this.$route.params.image)
    },
    copy_success() {
      this.$swal({title: 'Copied', text: 'Copied to clipboard', icon: 'success'})
    },
    copy_html_to_clipboard(str) {
      function listener(e) {
        e.clipboardData.setData("text/html", str);
        e.clipboardData.setData("text/plain", str);
        e.preventDefault();
      }
      document.addEventListener("copy", listener);
      document.execCommand("copy");
      document.removeEventListener("copy", listener);

      this.copy_success()
    }
  }
}
</script>

<style>
.breadcrumbs {
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  display: inline-block;
}

.when-open {
  display: inline-block;
}

.when-closed {
  display: none;
}

.collapsed > .when-open {
  display: none;
}

.collapsed > .when-closed {
  display: inline-block;
}

</style>
